import { render } from "./Teetimes.vue?vue&type=template&id=53d5227a&scoped=true"
import script from "./Teetimes.vue?vue&type=script&lang=js"
export * from "./Teetimes.vue?vue&type=script&lang=js"

import "./Teetimes.vue?vue&type=style&index=0&id=53d5227a&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d5227a"]])

export default __exports__